export const SITE_URL = "https://zarkit.com";
export const BRAND_NAME = "Zarkit";
export const LEGAL_NAME = "Zarkit Group";
export const TAGLINE = "Time Pe Delivery, Har Baar.";
export const SUPPORT_EMAIL = "support@zarkit.com";
export const SUPPORT_PHONE = "+91-8882283046";
export const SUPPORT_HOURS = "Monday to Saturday, 9:00 AM to 6:00 PM";
export const SOCIAL_IMAGE = `${SITE_URL}/zarkit-group.png`;
export const LOGO_IMAGE = `${SITE_URL}/zarkit-z.png`;

export const ADDRESS = {
  streetAddress: "Jouri Bujurg, Near Parichha",
  addressLocality: "Jhansi",
  addressRegion: "Uttar Pradesh",
  postalCode: "284121",
  addressCountry: "IN",
};

export const CITY_SERVICE_AREA = "Jhansi";
export const REGION_SERVICE_AREA = "Jhansi, Uttar Pradesh";

export const PUBLIC_ROUTES = [
  "/",
  "/about",
  "/privacy-policy",
  "/terms-conditions",
  "/delete-account",
];

export function absoluteUrl(path = "/") {
  return `${SITE_URL}${path === "/" ? "" : path}`;
}

export function fullAddress() {
  return `${ADDRESS.streetAddress}, ${ADDRESS.addressLocality}, ${ADDRESS.addressRegion} ${ADDRESS.postalCode}, India`;
}
